import { CloseIcon } from "@/components/icons/close-icon";
import { FilledButton } from "@/components/ui/buttons";
import { memo } from "react";

interface SkipMealButtonProps {
  /**
   * Callback when skip button is clicked
   */
  onSkip: () => void;
  /**
   * Whether the button is disabled
   */
  disabled?: boolean;
  /**
   * Aria label for accessibility
   */
  ariaLabel?: string;
}

/**
 * Button to skip to the next meal in the swiper
 * Displays a filled button with an X icon
 */
export const SkipMealButton = memo(function SkipMealButton({
  onSkip,
  disabled = false,
  ariaLabel = "Skip to next meal",
}: SkipMealButtonProps) {
  return (
    <FilledButton
      color="black"
      onClick={onSkip}
      disabled={disabled}
      className="flex h-14 w-14 items-center justify-center rounded-full p-0"
      aria-label={ariaLabel}
    >
      <CloseIcon className="h-6 w-6 stroke-white" />
    </FilledButton>
  );
});
